export default ({ app, route }) => {
    window._AutofillCallbackHandler = window._AutofillCallbackHandler || function () {};

    const parts = route?.path?.split('/');

    let title = 'Pagina nu poate fi afișată în acest moment';
    let description =
        'Pentru continuare, avem nevoie de consimţămîntul Dvs pentru utilizare cookie-uri. Permisiunile de setare a modulelor cookie pot fi activate / dezactivate în setările browserului.';
    let btn = 'Reîncarcă';

    if (parts[1] === 'ro') {
        title = 'Pagina nu poate fi afișată în acest moment';
        description =
            'Pentru continuare, avem nevoie de consimţămîntul Dvs pentru utilizare cookie-uri. Permisiunile de setare a modulelor cookie pot fi activate / dezactivate în setările browserului.';
        btn = 'Reîncarcă';
    }

    if (parts[1] === 'ru') {
        title = 'Страница не может быть отображена в данный момент';
        description =
            'Для продолжение, нам необходимо Ваше согласие на использование файлов cookie. Разрешения по настройкам cookies можно активировать / отключить в настройках браузера.';
        btn = 'Обновить';
    }

    if (parts[1] === 'en') {
        title = 'The page cannot be displayed at the moment';
        description =
            'To continue, we need your consent to use cookies. Permissions to set cookies can be enabled / disabled in your browser settings.';
        btn = 'Reload';
    }

    try {
        if (!app.$cookies) {
            throw new Error('err');
        }

        if (!document.cookie) {
            throw new Error('err');
        }

        if (!window.localStorage) {
            throw new Error('err');
        }

        if (!window.sessionStorage) {
            throw new Error('err');
        }
    } catch {
        document.documentElement.innerHTML = `
        <html lang="en">
          <head>
              <meta charset="UTF-8">
              <meta name="viewport" content="width=device-width, initial-scale=1.0">
              <title>Storage Error</title>
                        <style>
                            * {
                              margin: 0;
                              padding: 0;
                              box-sizing: border-box;
                            }
                            html {
                              height: 100%;
                            }
                            body {
                                font-family: 'Helvetica', 'Arial', 'Roboto', system-ui;
                                background-color: #fff;
                                height: 100%;
                            }

                            h1, span {
                              text-align: center;
                            }

                            .wrapper {
                              display: flex;
                              height: 100%;
                              align-items: center;
                            }

                            .container {
                              padding: 12px;
                              display: flex;
                              margin: auto;
                              width: max-content;
                              flex-direction: column;
                              gap: 24px;
                            }

                            .request {
                              text-decoration: none;
                              margin: auto;
                              display: flex;
                              flex-direction: row;
                              justify-content: center;
                              align-items: center;
                              padding: 0px 25px;
                              background: black;
                              border: 1px solid rgba(0, 0, 0, 0.03);
                              border-radius: 10px;
                              height: 60px;
                              width: max-content;
                              font-weight: 600;
                              font-size: 18px;
                              line-height: 100%;
                              color: #fff;
                              transition: 0.3s;

                              &:hover {
                                cursor: pointer;
                              }
                            }
                        </style>
          </head>
          <body>
            <div class="wrapper">
                <div class="container">
                  <h1 id="title">${title}</h1>
                  <span id="subtitle">${description}</span>
                  <a href="${route?.path}" class="request">${btn}</a>
                </div>
            </div>
          </body>
        </html>
      `;
    }
};
